import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientNegotiateList のスタイル
 */
export const hotlineClientNegotiateListStyle = tv({
    slots: {
        base: ['flex flex-row items-start gap-x-8'],
        content: ['grow', 'w-full'],
        list: ['shrink-0', 'px-8', 'border border-solid border-light'],
        listWrap: [
            'max-h-[494px] overflow-y-auto',
            'hidden md:block lg:hidden xl:block',
            'w-[216px]',
            'shrink-0',
            'pr-16',
        ],
    },
});
